import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import BannerSection from "../component/section/banner";
import matrimonyInstance from "../utils/axios";
import { FORGET_PASSWORD, LOGIN } from "../API_LIST";
import { toastMaker } from "../utils/utility";

const title = "Forgot Password?";
const subtitle = "Login With Social Media";

const ForgotPasswordPage = () => {
	const [userData, setUserData] = useState({
		email: "",
	});

	const handleChange = (e) => {
		setUserData((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};

	const sendForgotPassword = async (e) => {
		e.preventDefault();
		matrimonyInstance.post(FORGET_PASSWORD, userData).then((response) => {
			toastMaker("Email sent", "success");
		});
	};

	return (
		<div>
			<BannerSection />
			<div className=" container">
				<div className="login-section padding-tb">
					<div className="row align-items-center">
						<div className="account-container">
							<h3 className="account-title">{title}</h3>
							<div className="row justify-content-between">
								<div className="col-12 col-lg-7 col-sm-12">
									<div className="account-wrapper">
										<form onSubmit={sendForgotPassword}>
											<div className="account-form">
												<div className="form-title">
													Enter your email address to recover your password.
												</div>
												<div className="row mt-20 justify-content-center">
													<div className="col-lg-12 col-sm-12 col-12 px-3">
														<div className="form-group">
															<div className="input-title">
																Profile Id / Email Id
															</div>
															<div className="input-field position-relative">
																<input
																	type="email"
																	id="item01"
																	placeholder="Email"
																	className="input-icon"
																	name="email"
																	value={userData.email}
																	onChange={handleChange}
																/>
																<div className="login-icon">
																	<img
																		src="./assets/images/bat-img/login-email.svg"
																		alt="email icon"
																	/>
																</div>
															</div>
														</div>
													</div>
													<div className="forgot-password-content justify-content-end">
														<button
															className="button login-btn text-white fw-600"
															onClick={sendForgotPassword}
														>
															Send Password Link
														</button>
													</div>
												</div>
											</div>
										</form>
										<div className="forgot-password-content d-flex justify-content-center">
											<a href="forgot-password">Back to Login</a>
										</div>
									</div>
								</div>
								<div className="col-12 col-lg-5 col-sm-12">
									<div className="right-image-container">
										<img
											src="./assets/images/bat-img/login-img.svg"
											alt="login image"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<FooterSection />
		</div>
	);
};

export default ForgotPasswordPage;
